<template>
    <main-content v-if="$can('manage', 'gateway') && corporate_details" with_go_back_bar>
        <div v-if="corporate_details">
            <corporate-form :form_data="corporate_details" :submit="editCorporate"></corporate-form>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {mapGetters} from "vuex";
import {billService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app';
import corporateForm from "./components/corporate-form";

export default {
    data() {
        return {
            corporate_details: null
        }
    },
    components: {
        'main-content': mainContent,
        corporateForm
    },
    computed: {},
    mounted() {
        billService.findCorporate(this.$route.params.hashid).then(response => {
            this.corporate_details = response.data.data
        })
    },
    methods: {
        editCorporate(form, btn) {
            KTApp.progress(btn)
            this.corporate_details.corporate_id = this.$route.params.hashid;

            billService.editCorporate(this.corporate_details).then(response => {
                this.$router.push('/bill')
            }).catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data);
                }
                return this.showMsg(form, 'danger',response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>

<style>

</style>